
const ACCOUNT_IDS = {
  dev: '381491914047',
  stage: '891377321414',
  prod: '905418403214',
  customer: '585768162250',
};

const startRum = async (datadog) => {

  // The backend decides per environment and withholds the credentials when disabled, so there is
  // nothing to start unless it says so.
  if (!datadog?.enabled) {
    return null;
  }

  const { datadogRum } = await import('@datadog/browser-rum'); // lazy loading to separate datadog into chunk

  datadogRum.init({
    applicationId: datadog.applicationId,
    clientToken: datadog.clientToken,
    site: datadog.site,
    service: datadog.service,
    env: CONFIG.environment,
    allowedTracingUrls: [document.location.origin],
    version: window.osloVersion,
    sessionSampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,  // Enables tracking API calls
    trackLongTasks: true
  });

  datadogRum.setGlobalContextProperty('project', 'oslo');
  datadogRum.setGlobalContextProperty('product', 'moment');
  datadogRum.setGlobalContextProperty('account_id', ACCOUNT_IDS[CONFIG.environment]);

  return datadogRum;
};

export async function initializeDataDog ({ datadog, userId, userName, userEmail, companyId, companyCode, isImpersonating }) {

  const datadogRum = await startRum(datadog);
  if (!datadogRum) {
    return;
  }

  datadogRum.setUser({
    id: userId,
    name: userName,
    email: userEmail
  });

  datadogRum.setGlobalContextProperty('companyId', companyId);
  datadogRum.setGlobalContextProperty('companyCode', companyCode);
  datadogRum.setGlobalContextProperty('isImpersonating', isImpersonating);
}

// Signup, login and the public offer/review pages render without a session, so they carry no user or
// company context. Without this they emit no telemetry at all, which also hides CSP violations there.
export async function initializePublicDataDog (loadPublicOptions) {
  const { datadog } = await loadPublicOptions();
  await startRum(datadog);
}
